module.exports = __webpack_public_path__ + "img/liyou1.e8c22e2d.png";